import * as React from 'react';
import { RenderLeafProps } from 'slate-react';
import { RenderLeaf, SlatePlugin } from '../types';

const EditorSlowLeafTagBase = ({ leafProps, renderLeafList, plugins }) => {
  const localLeafProps: RenderLeafProps = { ...leafProps }; // workaround for children readonly error.
  renderLeafList.forEach((renderLeaf) => {
    localLeafProps.children = renderLeaf(localLeafProps);
  });

  plugins.forEach(({ renderLeaf }) => {
    if (!renderLeaf) return;
    localLeafProps.children = renderLeaf(localLeafProps);
  });

  return <span {...localLeafProps.attributes}>{localLeafProps.children}</span>;
};

const EditorSlowLeafTag = React.memo(EditorSlowLeafTagBase);

export const renderLeafPlugins = (plugins: SlatePlugin[], renderLeafList: RenderLeaf[]) => {
  return (leafProps: RenderLeafProps) => {
    return (
      <EditorSlowLeafTag renderLeafList={renderLeafList} plugins={plugins} leafProps={leafProps} />
    );
  };
};
